import Settings from '@/config/Settings'

console.log.apply(console, [
  `%c ♥ ${Settings.author} ♥ `,
  'color: #fff; background: #030307; padding:5px 0;'
])

if(process.env.NODE_ENV === 'production') {
  console.log = function() {}
  console.warn = function() {}
}

  console.warn = function() {}



// WEBPACK FOOTER //
// ./src/core/js/Copyright.js